import {
  ALCOHOL_ADD_REQUEST,
  ALCOHOL_ADD_SUCCESS,
  ALCOHOL_ADD_FAILURE,
  ALCOHOL_EDIT_REQUEST,
  ALCOHOL_EDIT_SUCCESS,
  ALCOHOL_EDIT_FAILURE,
  ALCOHOL_VIEW_REQUEST,
  ALCOHOL_VIEW_SUCCESS,
  ALCOHOL_VIEW_FAILURE,
  ALCOHOL_VIEW_ALL_REQUEST,
  ALCOHOL_VIEW_ALL_SUCCESS,
  ALCOHOL_VIEW_ALL_FAILURE,
  ALCOHOL_DELETE_REQUEST,
  ALCOHOL_DELETE_SUCCESS,
  ALCOHOL_DELETE_FAILURE,
  ALCOHOL_RESET_STATE,
  ALCOHOL_SEARCH_REQUEST,
  ALCOHOL_SEARCH_SUCCESS,
  ALCOHOL_SEARCH_FAILURE,
  ALCOHOL_PERCENTAGE_VIEW_REQUEST,
  ALCOHOL_PERCENTAGE_VIEW_SUCCESS,
  ALCOHOL_PERCENTAGE_VIEW_FAILURE,
  WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_REQUEST,
  WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_SUCCESS,
  WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_FAILURE,
} from "./TypeOfAlcoholTypes";

// Add Alcohol Actions
export const alcoholAddRequest = (credentials) => ({
  type: ALCOHOL_ADD_REQUEST,
  payload: credentials,
});

export const alcoholAddSuccess = (alcohol) => ({
  type: ALCOHOL_ADD_SUCCESS,
  payload: alcohol,
});

export const alcoholAddFailure = (error) => ({
  type: ALCOHOL_ADD_FAILURE,
  payload: error,
});

// Edit Alcohol Actions
export const alcoholEditRequest = (alcoholId) => ({
  type: ALCOHOL_EDIT_REQUEST,
  payload: { alcoholId },
});

export const alcoholEditSuccess = (alcohol) => ({
  type: ALCOHOL_EDIT_SUCCESS,
  payload: alcohol,
});

export const alcoholEditFailure = (error) => ({
  type: ALCOHOL_EDIT_FAILURE,
  payload: error,
});

// View Single Alcohol Actions
export const alcoholViewRequest = (alcoholId) => ({
  type: ALCOHOL_VIEW_REQUEST,
  payload: alcoholId,
});

export const alcoholViewSuccess = (alcohol) => ({
  type: ALCOHOL_VIEW_SUCCESS,
  payload: alcohol,
});

export const alcoholViewFailure = (error) => ({
  type: ALCOHOL_VIEW_FAILURE,
  payload: error,
});

// View All Alcohol Actions
export const alcoholViewAllRequest = (payload) => ({
  type: ALCOHOL_VIEW_ALL_REQUEST,
  payload,
});

export const alcoholViewAllSuccess = (alcoholList) => ({
  type: ALCOHOL_VIEW_ALL_SUCCESS,
  payload: alcoholList,
});

export const alcoholViewAllFailure = (error) => ({
  type: ALCOHOL_VIEW_ALL_FAILURE,
  payload: error,
});

// View Alcohol Percentage Actions
export const alcoholPercentageViewRequest = () => ({
  type: ALCOHOL_PERCENTAGE_VIEW_REQUEST,
});

export const alcoholPercentageViewSuccess = (alcoholList) => ({
  type: ALCOHOL_PERCENTAGE_VIEW_SUCCESS,
  payload: alcoholList,
});

export const alcoholPercentageViewFailure = (error) => ({
  type: ALCOHOL_PERCENTAGE_VIEW_FAILURE,
  payload: error,
});

// View Wholesaler Alcohol Percentage Actions
export const WholesalerAlcoholPercentageViewRequest = () => ({
  type: WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_REQUEST,
});

export const WholesalerAlcoholPercentageViewSuccess = (alcoholList) => ({
  type: WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_SUCCESS,
  payload: alcoholList,
});

export const WholesalerAlcoholPercentageViewFailure = (error) => ({
  type: WHOLESALER_ALCOHOL_PERCENTAGE_VIEW_FAILURE,
  payload: error,
});

// View All Search Alcohol Actions
export const alcoholSearchViewAllRequest = () => ({
  type: ALCOHOL_SEARCH_REQUEST,
});

export const alcoholSearchViewAllSuccess = (alcoholList) => ({
  type: ALCOHOL_SEARCH_SUCCESS,
  payload: alcoholList,
});

export const alcoholSearchViewAllFailure = (error) => ({
  type: ALCOHOL_SEARCH_FAILURE,
  payload: error,
});

// Delete Alcohol Actions
export const alcoholDeleteRequest = (alcoholId) => ({
  type: ALCOHOL_DELETE_REQUEST,
  payload: alcoholId,
});

export const alcoholDeleteSuccess = (alcoholId) => ({
  type: ALCOHOL_DELETE_SUCCESS,
  payload: alcoholId,
});

export const alcoholDeleteFailure = (error) => ({
  type: ALCOHOL_DELETE_FAILURE,
  payload: error,
});

// Reset Alcohol State
export const alcoholResetState = () => ({
  type: ALCOHOL_RESET_STATE,
});
